// Tailwind reusable class compositions

// Layout
export const PageDefault = ""
// 3xl:w-6/1
export const CasesLayout = "mx-auto md:w-k8 lg:w-k7 xl:w-k7 2 mt-k3v"
// Menu
export const LayoutLinks = "py-2 px-4 text-xs"
export const Lead = "fluid-text-lg mb-16 "
export const Label = "mb-4 md:mb-0 uppercase md:normal-case fluid-text-sm  tracking-normal"
export const MenuLabel = `text-xxs 2xl:text-xs uppercase leading-none tracking-widest block 
text-black-shade-600`
export const GhostButton = `button px-4 mt-4 leading-none py-3 border text-violet-600 dark:text-violet-400 border-violet-600 dark:border-violet-400 hover:bg-violet-600 hover:text-white dark:hover:bg-violet-400 dark:hover:text-black`
// export const MenuLabel = `text-xs 2xl:text-sm uppercase tracking-widest block ${Label}`;
export const PageTitle = "fluid-text-3xl"
// INterface
export const TopPos = "top-k0v sm:top-k1v mt-0"
export const LeftPos = "left-k1v  " // lg:left-k0 2xl:left-k1
export const MidPos = "top-1/2"
export const RightPos = "right-k1" // lg:right-k0 2xl:right-k1
export const BottomPos = "2xl:mb-0 bottom-k0 2xl:bottom-k1"
// Grid
export const LeftSide = "block w-full md:w-k25"
export const LeftContent =
  "block  w-full md:w-k75 2xl:w-k75 2xl:pr-0 mb-7"
// Content
export const Job = "mb-6 sm:mb-16"
// Project Page
export const Project_Detail =
  "flex flex-col md:flex-row items-baseline mx-auto w-k7 xs:w-k8 md:w-k7 lg:w-k6 xl:w-k5 3xl:w-k4"
export const Project_Detail_Label = "mt-0 w-full md:w-k25 mb-4 md:mb-0"
export const Project_Detail_Content = "w-full "
